import { Sparkle } from "lucide-react";
import PortraitFrame from "./PortraitFrame";
import { Reveal, ChapterHeading } from "./Reveal";
import { ABOUT, IMAGES } from "@/config";

const About = () => (
  <section id="hakkimda" data-testid="about-section" className="relative z-10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-5 max-w-md mx-auto w-full lg:max-w-none order-2 lg:order-1">
        <div className="relative">
          <PortraitFrame src={IMAGES.aboutPortrait} arch={false} testId="about-portrait" />
          <div className="absolute -bottom-8 -right-3 sm:-right-8 w-36 sm:w-44 rotate-3 rounded-xl border border-gold/40 bg-navy p-1.5 shadow-[0_24px_60px_-15px_rgba(0,0,0,0.65)]">
            <img
              src={IMAGES.aboutOverlap}
              alt="Astrolog gülümserken"
              data-testid="about-overlap-photo"
              className="aspect-[4/5] w-full rounded-lg object-cover"
              style={{ objectPosition: "center 20%" }}
            />
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7 order-1 lg:order-2">
        <ChapterHeading chapter={ABOUT.chapter} label={ABOUT.label} title={ABOUT.title} />
        {ABOUT.paragraphs.map((p, i) => (
          <Reveal key={i} delay={0.15 + i * 0.1}>
            <p className="mt-6 text-mist text-base md:text-lg leading-relaxed max-w-2xl">{p}</p>
          </Reveal>
        ))}
        <Reveal delay={0.35}>
          <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif italic text-xl sm:text-2xl text-cream max-w-xl">
            “{ABOUT.quote}”
          </blockquote>
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-2xl">
          {ABOUT.highlights.map((h, i) => (
            <Reveal key={h} delay={0.1 + i * 0.08}>
              <div
                className="flex items-center gap-3 rounded-xl border border-gold/20 bg-navy-800/50 px-5 py-4"
                data-testid={`about-highlight-${i}`}
              >
                <Sparkle className="w-4 h-4 text-gold shrink-0" />
                <span className="text-sm text-cream/90">{h}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
